import React, { useState } from 'react';
import { Button, Link, Switch, TableCell, TableRow, Theme, Tooltip, createStyles, makeStyles } from '@material-ui/core';
import CreateRoundUtil from '../CreateRound/CreateRoundUtil';
import { useHistory, Link as RouterLink } from "react-router-dom";
import { League } from './LeagueModels';
import { GenericResponse } from '../CreateRound/CreateRoundModels';
import ApiNgUtil from '../api/ApiNgUtil';
import LeagueUtil from './LeagueUtil';
import UpdateIcon from '@material-ui/icons/Update';
import ErrorOutlineIcon from '@material-ui/icons/ErrorOutline';

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    tableRow: {
      "&:hover":{
        cursor: "pointer"
      }
    }
  }),
);

enum UpdateMode {
  None,
  Enabled,
  Sync
}
interface LeagueRowState {
  updating : boolean;
  mode: UpdateMode;
  enabledUpdate : number;
  enabledError?: string;
  syncError?: string;
}

interface LeagueRowProps {
  league: League;
  selected: boolean;
  onSelect?: (item?: League) => void;
}
const LeagueRow: React.FC<LeagueRowProps> = (props) => {
  const classes = useStyles();
 
  const [leagueState, setLeagueState] = useState<LeagueRowState>({
    updating: false,
    mode: UpdateMode.None,
    enabledUpdate: 0
  });
  const history = useHistory();

  const onSelect = () => {
    if (props.onSelect) {
      if (props.selected) {
        props.onSelect(undefined);
      } else {
        props.onSelect(props.league);
      }
      return;
    }
  };

  const endEnabledUpdating = (enabledError?: string) => {
    setLeagueState({
      updating: false,
      mode: UpdateMode.None,
      enabledUpdate: 0,
      enabledError: enabledError
    });
  };  
  const endSyncUpdating = (syncError?: string) => {
    setLeagueState({
      updating: false,
      mode: UpdateMode.None,
      enabledUpdate: 0,
      syncError: syncError
    });
  };  

  const updateLeague = async (updateJson: string, caller: string) : Promise<GenericResponse<League>> => {
    const methodName = "UpdateLeague." + caller;
    try {

        var respX = await LeagueUtil.updateLeague(props.league.id, updateJson);
        return respX;
    } catch (error){
      console.error(methodName + " error!", error);
      return CreateRoundUtil.createGenericResponse<League>(false, methodName + " error: " + error, null);

    }
  }
  

  const onEnabledChange = () => {
    setLeagueState({
      updating: true,
      mode: UpdateMode.Enabled,
      enabledUpdate:  props.league.enabled ? -1 : 1
    });
    let updateJson = JSON.stringify({
      enabled: !props.league.enabled
    });
    updateLeague(updateJson, "onEnabledChange").then(resp => {
      if (resp.success){
        if (resp.item){
          props.league.enabled = resp.item.enabled;
        }
        endEnabledUpdating();
      } else {
        endEnabledUpdating(resp.message);
      }
    });
  };
  
  const onSync = () => {
    setLeagueState({
      updating: true,
      mode: UpdateMode.Sync,
      enabledUpdate:  0
    });
    
    LeagueUtil.syncLeague(props.league.id).then(resp => {
      if (resp.success){
        endSyncUpdating();
      } else {
        endSyncUpdating(resp.message);
      }
    });
  };
 

  var row = props.league;
  var enabledTooltip = null;
  var syncTooltip = null;
  var tooltipStyle = {
    marginLeft: 2
  };
  var leagueEnabled = row.enabled;
  if (leagueState.updating){
    switch (leagueState.mode) {
      case UpdateMode.Enabled:
        enabledTooltip = (<Tooltip title="Updating enabled state..." style={tooltipStyle}><UpdateIcon fontSize="small"/></Tooltip>);
        break;
      case UpdateMode.Sync:
        syncTooltip = (<Tooltip title="Syncing league..." style={tooltipStyle}><UpdateIcon fontSize="small"/></Tooltip>);
        break;
    }
    switch (leagueState.enabledUpdate) {
      case 1:
        leagueEnabled = true;
        break;
      case -1:
        leagueEnabled = false;
        break;
    }
  } else if (leagueState.enabledError) {
    enabledTooltip = (<Tooltip title={"Error updating enabled state: " + leagueState.enabledError} style={tooltipStyle}><ErrorOutlineIcon color="error" fontSize="small"/></Tooltip>);
  } else if (leagueState.syncError) {
    syncTooltip = (<Tooltip title={"Error syncing league: " + leagueState.syncError} style={tooltipStyle}><ErrorOutlineIcon color="error" /></Tooltip>);
  }
  var syncBtn = (<Button variant="outlined" color="secondary" size="small" disabled={leagueState.updating} onClick={(e: any) => onSync()}>Sync</Button>);

  return (
    <TableRow 
        key={row.id} 
        hover
        onClick={(e: any) => onSelect()}
        selected={props.selected}
        className={classes.tableRow}
    >
      <TableCell  align='right' component="th" scope="row">
        <Link component={RouterLink} to={"leagues/" + row.id}>{row.id}</Link>
      </TableCell>
      <TableCell>
        {row.name}
      </TableCell>
      <TableCell>
        {row.countryName}
      </TableCell>
      <TableCell>
        {row.sportName}
      </TableCell>
      <TableCell>
        {CreateRoundUtil.toGameDateString(row.createdAt)}
      </TableCell>
       <TableCell >
        <Switch
            checked={leagueEnabled}
            onChange={(e: any) => onEnabledChange()}
            inputProps={{ 'aria-label': 'controlled' }}
            disabled={leagueState.updating}
            size="small"
          />{enabledTooltip}
       </TableCell>
       <TableCell align='right'>
        {row.nFixtures}
       </TableCell>
       <TableCell align='right'>
        {row.nMappings}
       </TableCell>
       <TableCell>
        {syncBtn}{syncTooltip}
      </TableCell>
    </TableRow>    
  );
 
};

export default LeagueRow;
